import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "👑", key: "regal" },
  { emoji: "🤪", key: "goofy" },
  { emoji: "😌", key: "calm" },
  { emoji: "⚡", key: "wild" },
]

export default function PetsCurrentSetupPage() {
  return (
    <RadioCardListPage translationKey="petsCurrentSetup" options={OPTIONS} />
  )
}
